import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format, parseISO } from "date-fns";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ServiceTemplateScheduleRow } from "../serviceTemplateSchedulesViewConfig";
import { SCHEDULE_DATE_FORMAT } from "../serviceTemplateSchedule.constants";

export const ServiceTemplateScheduleCreatedAtCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ServiceTemplateScheduleRow, Date>) => {
        // Group rows aggregate multiple schedules created at different
        // times — no single createdAt is meaningful, so always dash.
        if (row.original.rowType === "group") {
            return (
                <ViewTableCell>
                    <span>-</span>
                </ViewTableCell>
            );
        }

        const { createdAt } = row.original;

        // `createdAt` is typed `Date` (`z.coerce.date()`), but the ts-rest
        // client returns the raw response body without running the schema, so
        // at runtime it's the ISO string the API serialised. Parse it
        // explicitly with `parseISO` (per the date-fns convention, matching the
        // sibling next-occurrence cells) rather than leaning on `format()`'s
        // lenient string coercion.
        const createdAtDate =
            typeof createdAt === "string" ? parseISO(createdAt) : createdAt;

        return (
            <ViewTableCell>
                <span>
                    {createdAt
                        ? format(createdAtDate, SCHEDULE_DATE_FORMAT)
                        : "-"}
                </span>
            </ViewTableCell>
        );
    },
);

ServiceTemplateScheduleCreatedAtCell.displayName =
    "ServiceTemplateScheduleCreatedAtCell";
